export const financePrepaid = {
  'finance.prepaid.create': 'יצירת רכישה',
  'finance.prepaid.service': 'שירות',
  'finance.prepaid.package': 'חבילה שפורסמה',
  'finance.prepaid.customServices': 'בחירת שירותים נפרדת',
  'finance.prepaid.addService': 'הוספת שירות',
  'finance.prepaid.removeService': 'הסרת שירות',
  'finance.prepaid.previewPurchase': 'תצוגה מקדימה של הרכישה',
  'finance.prepaid.purchaseTerms': 'תנאי הרכישה',
  'finance.prepaid.quotedQuantity': 'כמות: {quantity}',
  'finance.prepaid.selectionRequired': 'יש לבחור מקבל שירות, סניף ושירותים בכמויות חיוביות. הכמות הכוללת לא יכולה לעלות על מיליון יחידות.',
  'finance.prepaid.purchasePreviewRequired': 'יש לקבל תצוגה מקדימה עדכנית של הרכישה לפני האישור.',
  'finance.prepaid.title': 'רכישות מראש',
  'finance.prepaid.description': 'מימון, יחידות שירות ויתרה שלא נוצלה',
  'finance.prepaid.purchase': 'רכישה מראש',
  'finance.prepaid.beneficiary': 'מקבל השירות',
  'finance.prepaid.date': 'תאריך הרכישה',
  'finance.prepaid.state': 'מצב',
  'finance.prepaid.pending': 'ממתינה לתשלום מלא',
  'finance.prepaid.active': 'פעילה',
  'finance.prepaid.canceled': 'בוטלה',
  'finance.prepaid.price': 'מחיר הרכישה',
  'finance.prepaid.funded': 'שולם',
  'finance.prepaid.consumed': 'נוצל',
  'finance.prepaid.released': 'שוחרר',
  'finance.prepaid.remaining': 'יתרה מוחזקת',
  'finance.prepaid.lines': 'שירותים',
  'finance.prepaid.quantities': 'נרכשו: {purchased}; נוצלו: {used}; הוחזרו: {returned}; זמינים: {available}',
  'finance.prepaid.fund': 'הוספת מימון',
  'finance.prepaid.cancel': 'ביטול הרכישה',
  'finance.prepaid.return': 'החזרת יחידות שלא נוצלו',
  'finance.prepaid.loading': 'טעינת רכישות מראש',
  'finance.prepaid.empty': 'אין רכישות מראש',
  'finance.prepaid.emptyDetail': 'טרם נרשמו רכישות.',
  'finance.prepaid.noMatches': 'לא נמצאו רכישות',
  'finance.prepaid.noMatchesDetail': 'אין רכישות במצב שנבחר.',
  'finance.prepaid.failed': 'לא ניתן היה להשלים את הפעולה ברכישה מראש.',
  'finance.prepaid.changed': 'הרכישה או חשבון המקור השתנו. יש לטעון שוב את הנתונים השמורים.',
  'finance.prepaid.stateChanged': 'מצב הרכישה אינו מאפשר פעולה זו.',
  'finance.prepaid.unitsUnavailable': 'חלק מהיחידות שנבחרו אינן זמינות עוד.',
  'finance.prepaid.fundingExceeded': 'הסכום גדול מיתרת התשלום עבור הרכישה.',
  'finance.prepaid.unsaved': 'פרטי רכישה מראש שלא נשמרו',
  'finance.prepaid.reasonRequired': 'יש לציין סיבה באורך של שלושה תווים לפחות.',
  'finance.prepaid.previewRequired': 'יש לבחור יחידות זמינות ולקבל חישוב החזרה עדכני.',
  'finance.prepaid.confirm': 'אישור',
  'finance.prepaid.saving': 'שמירה',
  'finance.prepaid.unitRange': 'יחידות {first} עד {last}',
  'finance.prepaid.firstUnit': 'היחידה הראשונה',
  'finance.prepaid.quantity': 'כמות',
  'finance.prepaid.more': 'טעינת נוספים',
  'finance.prepaid.preview': 'חישוב ההחזרה',
  'finance.prepaid.releaseAmount': 'החזרה לכספי המקור',
  'finance.prepaid.net': 'ללא מס',
  'finance.prepaid.tax': 'מס כלול',
  'finance.prepaid.noPayout': 'הערך מוחזר לחשבונות המקור. לא נרשם תשלום כספי יוצא.',
  'finance.prepaid.reason': 'סיבה',
  'finance.prepaid.unfunded': 'יתרה לתשלום',
  'finance.prepaid.fundsOwner': 'בעל חשבון המקור',
  'finance.prepaid.account': 'חשבון המקור',
  'finance.prepaid.noAccounts': 'לבעל החשבון אין חשבונות פעילים.',
  'finance.prepaid.receipt': 'תקבול המקור',
  'finance.prepaid.receiptOption': '{date}: זמינים {amount}',
  'finance.prepaid.noReceipts': 'אין תקבולים בחשבון זה.',
  'finance.prepaid.receiptRequired': 'יש לבחור חשבון מקור ותקבול.',
  'finance.prepaid.maximum': 'זמין לרכישה זו',
  'finance.prepaid.amount': 'סכום המימון',
  'finance.prepaid.amountRequired': 'יש להזין סכום חיובי שאינו עולה על היתרה הזמינה.',
  'finance.prepaid.ownerInstruction': 'בעל החשבון אישר מימון עבור מקבל שירות זה.',
  'finance.prepaid.instructionRequired': 'יש לאשר את הוראת בעל החשבון.',
  'finance.prepaid.reference': 'אסמכתה להוראת המימון',
  'finance.prepaid.referenceRequired': 'יש להזין אסמכתה באורך של שלושה תווים לפחות.',
} as const
